import { render, staticRenderFns } from "./serviceSettingTab.vue?vue&type=template&id=5e898667&scoped=true&"
import script from "./serviceSettingTab.vue?vue&type=script&lang=js&"
export * from "./serviceSettingTab.vue?vue&type=script&lang=js&"
import style0 from "./serviceSettingTab.vue?vue&type=style&index=0&id=5e898667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e898667",
  null
  
)

export default component.exports